<template>
<div class="gp-content">
  <content-nav-bar class="content-nav-bar">
      <a v-on:click="submit()" class="add button level-item">
        <i class="far fa-save"></i>
        Save
      </a>
      <p class="level-item">Select or deselect controls to make changes</p>
      <loader class="level-item" :showLoader="showLoader">Saving Insight Configuration</loader>
  </content-nav-bar>
  <content-nav-bar class="secondary">
    <svgicon
      name="filter"
      width="30"
      height="30"
      color="#63CCCA"
      :original="true"
      class="level-item">
    </svgicon>
    <span class="level-item">
      <span
        @click="active = 'All'"
        class="tag is-rounded level filter"
        :class="{ active: active === 'All' }">
        <svgicon
          name="circle"
          width="25"
          height="25"
          class="level-item">
        </svgicon>
        <span class="level-item">All ({{ allCount }})</span>
      </span>
    </span>
    <span
      v-for="option in allFilterOptions"
      :key="option.id"
      class="level-item">
      <span
        @click="active = option.title"
        class="tag is-rounded level filter"
        :class="{ active: active === option.title }">
        <svgicon
          :name="option.icon"
          width="25"
          height="25"
          class="level-item">
        </svgicon>
        <span class="level-item">{{ option.title }} ({{ option.length }})</span>
      </span>
    </span>
  </content-nav-bar>
  <div class="scroll-vertical full">
    <b-table
      :data="filteredValues"
      :checkable="false"
      :detailed="true"
      :showDetailIcon="true"
      detail-key="id">
      <template slot-scope="props">
        <b-table-column
          label="Enabled"
          centered
          class="enabled">
          <switch-watch
            :id="props.row.id"
            :value="props.row.enabled"
            :onChange="onChange"></switch-watch>
        </b-table-column>
        <b-table-column label="Type" centered class="type">
          <svgicon
            :name="props.row.icon"
            width="30"
            height="30"
            class="level-item">
          </svgicon>
        </b-table-column>
        <b-table-column label="Control" field="label" sortable>
          {{ props.row.label }}
        </b-table-column>
      </template>
      <template slot="detail" slot-scope="props">
        {{ props.row.description }}
      </template>
    </b-table>
  </div>
</div>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import insights from '@/mixins/insights';
import ContentNavBar from '@/components/ContentNavBar.vue';
import Loader from '@/components/Loader.vue';
import SwitchWatch from '@/components/SwitchWatch.vue';

export default {
  name: 'InsightsConfiguration',
  mixins: [insights],
  components: {
    ContentNavBar,
    Loader,
    SwitchWatch,
  },
  data() {
    return {
      showLoader: false,
      active: 'All',
    };
  },
  computed: {
    ...mapState(['disabledControls', 'keys']),
    filteredValues() {
      const values = [];
      this.defs.forEach((insight) => {
        if (this.active === 'All' || this.active === insight.shortTitle) {
          insight.values.forEach((value) => {
            values.push({
              icon: insight.icon,
              enabled: !this.disabledControls.includes(value.id),
              ...value,
            });
          });
        }
      });
      return values;
    },
  },
  methods: {
    ...mapMutations(['ADD_DISABLED_CONTROLS', 'REMOVE_DISABLED_CONTROLS']),
    async submit() {
      this.$log.debug('save');
      const response = await this.$store.dispatch('primary/createOrUpdateKeyValue', {
        key: this.keys.INSIGHTS_DISABLED,
        value: JSON.stringify(this.disabledControls),
      });
      if (response) {
        this.$log.debug('saved');
      }
    },
    remove(value) {
      this.internalFilter = this.internalFilter.filter(item => item !== value);
    },
    async onChange(id, enabled) {
      if (enabled) {
        this.REMOVE_DISABLED_CONTROLS(id);
      } else {
        this.ADD_DISABLED_CONTROLS(id);
      }
      this.$log.debug(`${id} - ${enabled}`);
    },
  },
};
</script>

<style lang="scss" scoped>
svg.level-item:not(:last-child) {
  margin: 0;
}

.filter {
  cursor: pointer;
  height: 25px;
}

.active {
  background: $main-background;
}


.type, .enabled {
  width: 75px;
}

/deep/ .b-table {
  .table {
    .checkbox-cell {
      padding-left: 1.3rem;
    }
  }
}
</style>
